<template>
  <div id="nav">
    <div v-if="!user && loginVisible" class="login-container">
      <Login/>
      <a @click="toggleLogin" href="#">
        <img src="../assets/logout.svg" alt="logout">
      </a>
    </div>
    <div class="login">
      <a v-if="!user && !loginVisible" @click="toggleLogin" class="btn">LOGIN</a>
      <a v-if="user" @click="logout" class="btn">Logout</a>
    </div>
    <div class="menu">
      <router-link to="/scrollitelling">
        <span>How is the weather?</span>
      </router-link>
      <router-link v-if="user" to="/weather-api">
        <span>Import data</span>
      </router-link>
      <router-link v-if="user" to="/weather-class">
        <span>Check weather data</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import Login from "@/components/Login";

export default {
  name: "Navbar",
  components: {
    Login
  },
  data() {
    return {
      user: null,
      loginVisible: false
    };
  },
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push({ name: "Scrollitelling" });
        });
    },
    toggleLogin() {
      this.loginVisible == true
        ? (this.loginVisible = false)
        : (this.loginVisible = true);
    }
  },
  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.user = user;
      } else {
        this.user = null;
      }
    });
  }
};
</script>

<style lang="stylus" scoped>
#nav {
  margin: 0 auto 20px;
  text-align: center;
  font-size: 16px;
  letter-spacing: 0.5px;
  display: relative;

  .menu {
    padding: 10px 0 0 0;

    & a {
      color: #666;
      margin: 0;
      padding: 5px;
      opacity: 0.5;
      text-decoration: none;

      & span {
        padding: 5px 15px;
      }

      & span:hover {
        opacity: 0.7;
        background-color: white;
        border-radius: 20px;
        transition: 0.7s;
      }

      &.router-link-exact-active {
        color: #934f07;
        opacity: 0.9;
      }
    }

    & a:not(:first-child)::before {
      content: '|';
      padding: 0 15px 0 0px;
    }

    & a:hover {
      opacity: 1;
    }
  }

  .login {
    position: absolute;
    top: 10px;
    right: 30px;

    // width: 100px
    & a.btn {
      font-size: 10px;
      text-transform: uppercase;
      text-decoration: none;
      padding: 5px;
      background-color: #934f07;
      color: white;
      cursor: pointer;
      opacity: 0.7;
      transition: 0.7s;
    }

    & a:hover {
      transition: 1.5s;
      opacity: 1;
    }
  }

  @keyframes slide-down {
    0% {
      opacity: 0;
      transform: translateY(-100px);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .login-container {
    position: absolute;
    z-index: 50;
    padding-top: 10px;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    background-color: white;
    margin: 0;
    box-shadow: 2px 2px 4px 0px #efe9e8;
    animation: slide-down 0.6s ease;

    & img {
      width: 24px;
      height: 24px;
      padding: 10px 40px;
    }
  }
}
</style>

